// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"13f6d854","981":"c15b5b4f"}[chunkId] + ".chunk.js";
};